import { BsPlusCircle, BsUpload } from 'react-icons/bs'
import { Link, useLocation } from 'react-router-dom'
import IconText from '../../../UtilComponent/level_1/IconText'
import { contactHeaders } from './contactHeaders'

type Props = {
  target: keyof typeof contactHeaders
}

const ContactBoxHeader = (props: Props) => {
  const { target } = props
  const { pathname } = useLocation()
  const headerItem = contactHeaders[target]

  return (
    <>
      <div className="cluster">
        <div className="cluster:child">
          <h5>{headerItem.title}</h5>
        </div>
        <div className="cluster">
          <div className="cluster:child">
            {headerItem.create && (
              <Link
                to={
                  pathname === headerItem.create.targetUrl
                    ? headerItem.create.baseUrl
                    : headerItem.create.targetUrl
                }
              >
                <IconText Icon={BsPlusCircle} text={headerItem.create.text} />
              </Link>
            )}

            {headerItem.import && (
              <Link
                to={
                  pathname === headerItem.import.targetUrl
                    ? headerItem.import.baseUrl
                    : headerItem.import.targetUrl
                }
              >
                <IconText Icon={BsUpload} text={headerItem.import.text} />
              </Link>
            )}
          </div>
        </div>
      </div>
      <hr />
    </>
  )
}

export default ContactBoxHeader
